/**
 * Locale Switcher Module
 *
 * Handles dropdown functionality and path-preserving locale switching.
 * Supports multiple instances on the same page.
 */

/**
 * Initialize a locale switcher instance
 * @param {HTMLElement} container - The locale switcher container element
 */
function initLocaleSwitcher(container) {
    const button = container.querySelector('[data-locale-switcher-button]')
    const dropdown = container.querySelector('[data-locale-switcher-dropdown]')
    const options = container.querySelectorAll('[data-locale-code]')

    if (!button || !dropdown) {
      return
    }

    let isOpen = false

    function openDropdown() {
      isOpen = true
      dropdown?.classList.remove('closed')
      button?.classList.add('open')
      button?.setAttribute('aria-expanded', 'true')
    }

    function closeDropdown() {
      isOpen = false
      dropdown?.classList.add('closed')
      button?.classList.remove('open')
      button?.setAttribute('aria-expanded', 'false')
    }

    function toggleDropdown() {
      if (isOpen) {
        closeDropdown()
      } else {
        openDropdown()
      }
    }

    button.addEventListener('click', (e) => {
      e.stopPropagation()
      toggleDropdown()
    })

    options.forEach((option) => {
      option.addEventListener('click', () => {
        closeDropdown()
      })
    })

    document.addEventListener('click', (e) => {
      // @ts-ignore
      if (!container.contains(e.target)) {
        closeDropdown()
      }
    })
  }

/**
 * Check if we're on a 404 page after a locale change and redirect to base URL if so
 */
function checkFor404Redirect() {
  const notFoundSection = document.getElementById('404-section')
  if (!notFoundSection) return
  
  const urlParams = new URLSearchParams(window.location.search)
  if (!urlParams.has('localeChanged')) return

  const localeSwitcher = document.querySelector('.locale-switcher')
  if (!localeSwitcher) return

  const baseUrl = localeSwitcher.getAttribute('data-current-locale-base-url')
  if (!baseUrl) return
  window.location.href = baseUrl
}

function init() {
  checkFor404Redirect()
  const switchers = document.querySelectorAll('.locale-switcher')
  switchers.forEach((switcher) => {
    // @ts-ignore
    initLocaleSwitcher(switcher)
  })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init)
} else {
  init()
}
